import React from "react";

// Create a new context
const LayoutContext = React.createContext();

export default LayoutContext;
